import { render, staticRenderFns } from "./appointment-request.vue?vue&type=template&id=47e3f3e1"
import script from "./appointment-request.vue?vue&type=script&lang=js"
export * from "./appointment-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports